module.exports = __webpack_public_path__ + "static/img/1.ba4034a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/1.png
// module id = lPGi
// module chunks = 1